<template>  

    <div>
        <div class="row" v-if="skeleton">
            <div  class="mb-2 col-md-12 placeholder-glow">
                <div class="placeholder mr-2 mb-2 rounded" style="height: 20px; width: 50px;"></div>
            </div>
            <div  class="pt-2 col-md-12 placeholder-glow">
                <div class="placeholder mr-2 mb-2 rounded" style="height: 25px; width: 100%;"></div>
                <div class="d-flex justify-content-between mt-3 placeholder-glow">
                    <div class="placeholder rounded" style="height: 35px; width: 30%;"></div>
                    <div class="placeholder rounded" style="height: 35px; width: 30%;"></div>
                </div>

            </div>
        </div>
        <client-only>
            <!-- <transition name="custom-transition" mode="out-in" > -->

                <div class="row slider-color"  v-show="!skeleton&&options">
                    <div v-if="filter && options && options.max"  class="col-12 d-flex mt-1 mb-2 align-items-center">
                        <span class="filter_title me-1 mb-1">{{ filter.label }}</span>  
                        <div class="ques_pop">
                                <span class="svgask">
                                    <ModalSlideModal :item="filter.label"/>
                                </span>
                            
                            <!-- <Clarity v-if="filter.name === 'clarity'" />
                            <Color v-if="filter.name === 'color'" /> 
                            <Cut v-if="filter.name === 'cut'" />
                            <Fluorescence  v-if="filter.name === 'fluorescence'" />
                            <Polish  v-if="filter.name === 'polish'" />
                            <Symmetry  v-if="filter.name === 'symmetry'" /> -->
                        </div>
                    </div>
                    <div v-if="options && options.max"  class="col-12 pt-2">
                        <div class="row number_row">
                            <div class="col-12 mb-3 mt-1 pe-4">
                                <div ref="slider"></div>
                            </div>
                        </div>
                        <ul class="d-flex list-unstyled justify-content-between custom_pips">
                            <li class="colr-label" v-for="v in options.values " :key="v">
                                {{v}}
                            </li>
                        </ul>
                    </div>
                </div>

            <!-- </transition> -->
        </client-only>
    </div>
    


</template>

<script setup>
    import { ref, computed, watch, nextTick, onMounted, onBeforeUnmount, inject } from 'vue'
    import noUiSlider from 'nouislider'
    
    import {cyolistStore}  from '@/stores/cyolist/cyolist';

    const props = defineProps(['name'])
    const moduleSubType = inject('moduleSubType')
    const store = cyolistStore()

    const skeleton = ref(true)
    const slider = ref(null)

    const filter = computed(() => store.getSettingFilter(moduleSubType, props.name))
    const options = computed(() => store.getSettingFilterOptions(moduleSubType, props.name))

    const sliderEligibility = () => !slider.value?.noUiSlider && options.value?.max && slider.value

    const initializeSlider = () => {
        noUiSlider.create(slider.value, {
            connect: true,
            behaviour: 'tap',
            margin: 1,
            step: 1,
            start: [options.value.from, options.value.to],
            range: {
                'min': parseFloat(options.value.min),
                'max': parseFloat(options.value.max),
            }
        })

        slider.value.noUiSlider.on('update', (values) => {
            options.value.from = parseFloat(values[0])
            options.value.to = parseFloat(values[1])
        })

        slider.value.noUiSlider.on('change', () => {
            const object = { reset: false, type: moduleSubType, filter: filter.value, option: { value: false } }
            store.toggleSettingFilter( object)
        })
    }

    onMounted( async () => {
        await nextTick()
        if (sliderEligibility()) {
            initializeSlider()
            skeleton.value = false
        }
    })

    onBeforeUnmount(() => {
        if (slider.value?.noUiSlider) {
            slider.value.noUiSlider.destroy()
        }
    })

    watch(options, (newVal) => {
        if (newVal) {
            nextTick(() => {
                if (slider.value?.noUiSlider && newVal.max) {
                    slider.value.noUiSlider.set([parseFloat(newVal.from), parseFloat(newVal.to)])
                }else if( sliderEligibility() ){
                    initializeSlider()
                    skeleton.value = false
                }
            })
        }
    })

</script>







<style scoped>
    .placeholder{
        background-color: rgba(0, 0, 0, 0.3);
    }
    .filter_title {
        color: #333333;
        font-size: 13px;
        font-weight: 700;
        text-transform: uppercase;
        line-height: normal;
    }
    .input-group input {
        border: 1px solid #c6cbd4;
        border-radius: 0;
        height: 30px;
        max-width: 100px;
        font-size: 14px;
    }
    .ques_pop {
        margin-top: -2px;
        height: 18px;
    }

    @media(max-width: 767px){
        .row.number_row {
            padding: 0 7px;
        }
    }
</style>
